<template>
    <div class="a-search-result overflow-ellipsis">
        <template v-if="searchTerm">
            <template v-if="canHighlight">
                {{ prefix }}<strong>{{ highlighted }}</strong
                >{{ suffix }}
            </template>
            <template v-else>
                {{ value }}
            </template>
        </template>
        <template v-else>
            {{ value }}
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    searchTerm: {
        type: String,
        default: null,
    },
    value: {
        type: String,
        required: true,
    },
})

const canHighlight = computed(() => {
    return !(searchTermIndex.value === -1);
})

const highlighted = computed(() => {
    return props.value.slice(
        searchTermIndex.value,
        searchTermIndex.value + searchTermLength.value
    );
})

const prefix = computed(() => {
    return props.value.slice(0, searchTermIndex.value);
})

const searchTermIndex = computed(() => {
    return props.value
        .toLowerCase()
        .indexOf(props.searchTerm.toLowerCase());
})

const searchTermLength = computed(() => {
    return props.searchTerm.length;
})

const suffix = computed(() => {
    return props.value.slice(
        searchTermIndex.value + searchTermLength.value,
        props.value.length
    );
})
</script>

<script>
    export default {
        name: 'AonSearchResult'
    }
</script>

<style lang="scss">
.a-search-result {
    display: inline-block;
    width: 100%;
}
</style>
